import { notification } from "antd";
import React, { useEffect } from "react";
import { Outlet } from "react-router-dom";
import { indianNames, interval } from "./data";

function getRandomTime() {
  // Generate random hours (between 0 and 23)
  const randomHours = Math.floor(Math.random() * 24);

  // Generate random minutes (between 0 and 59)
  const randomMinutes = Math.floor(Math.random() * 60);

  // Format the time as 2hr 35min
  const formattedTime = `${randomHours} hr ${randomMinutes} min`;

  return formattedTime;
}

function getRandomName(namesArray) {
  if (!Array.isArray(namesArray) || namesArray.length === 0) {
    return "Invalid names array";
  }

  const randomIndex = Math.floor(Math.random() * namesArray.length);
  const randomName = namesArray[randomIndex];

  return randomName;
}

const NotificationProvider = ({ children }) => {
  const [api, contextHolder] = notification.useNotification();
  const createSalesNotification = () => {
    let time = getRandomTime();
    let name = getRandomName(indianNames);

    let message = `${name} has puchased a product ${time} ago`;

    api.success({
      message,
      placement: "bottomLeft",
      closeIcon: true,
      duration: 4.5,
    });
  };

  useEffect(() => {
    let intervalId = setInterval(createSalesNotification, interval);

    return () => clearInterval(intervalId);
  }, []);
  return (
    <>
      {contextHolder}
      <Outlet />
    </>
  );
};

export default NotificationProvider;
